import type { BillingPeriod, SubscriptionTier } from "@/lib/plans";

type PaidSubscriptionTier = Exclude<SubscriptionTier, "free">;

interface StartSubscriptionCheckoutParams {
	plan: PaidSubscriptionTier;
	billingPeriod: BillingPeriod;
	promotionCode?: string;
	checkoutClientId?: string;
	successUrl: string;
	cancelUrl: string;
}

export class SubscriptionCheckoutError extends Error {
	status: number;

	constructor(message: string, status: number) {
		super(message);
		this.name = "SubscriptionCheckoutError";
		this.status = status;
	}
}

export async function startSubscriptionCheckout({
	plan,
	billingPeriod,
	promotionCode,
	checkoutClientId,
	successUrl,
	cancelUrl,
}: StartSubscriptionCheckoutParams): Promise<string> {
	const response = await fetch("/api/stripe/checkout", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		credentials: "include",
		body: JSON.stringify({
			plan,
			billingPeriod,
			promotionCode,
			checkoutClientId,
			successUrl,
			cancelUrl,
		}),
	});

	const data = (await response.json().catch(() => null)) as {
		error?: string;
		url?: string;
	} | null;

	if (!response.ok) {
		throw new SubscriptionCheckoutError(
			data?.error || "Failed to start checkout",
			response.status,
		);
	}

	if (!data?.url) {
		throw new Error("Checkout URL missing from response");
	}

	return data.url;
}
